import util from "@/mixins/util";
export default {
    mixins: [util],
    methods: {
        async log(logData = {
            depth : 1,
            access : '로그인/로그아웃'
        }, action='검색', client){
            let params = {
                clDepth: logData.depth,
                clAccess: logData.access,
                clAction: action,
            }
            if(!util.isEmpty(client) && !isNaN(client) && !isNaN(parseFloat(client))){
                params['mbNo'] = client
            }
            try{
                await this.$api.$log.createLog(params)
            }catch (e){
                console.log(e)
            }
        },
    }
}
